import { render, staticRenderFns } from "./WebhookCallEventData.vue?vue&type=template&id=22ce0efd"
import script from "./WebhookCallEventData.vue?vue&type=script&lang=js"
export * from "./WebhookCallEventData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports